const scrollStyleCallback = (): string => `
         overflow: hidden;
         /* Firefox: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Scrollbars */
         scrollbar-width: 10px;
         scrollbar-color: #ffffffbb transparent;
         scrollbar-width: thin;
         overflow-x: scroll;
         `;
export { scrollStyleCallback };
